import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'

// import Lightbox from 'react-images'
import Gallery from '../components/Gallery'
import References from '../components/references'
import Updates from '../components/updates'
import { pub, news, projects } from '../components/data.js'

class HomeIndex extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description

    return (
      <div>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>

        <div id="main">
          <section id="one">
            <ul className="actions">
              <li>
                I am working as a research scientist in 
                <a href="https://en.zhejianglab.com/">
                  {' '}
                  Zhejiang Lab
                </a>
               . Before that, I received my Ph.D. degree from 
               <a href="http://http://www.ust.hk/">
                  {' '}
                  Hong Kong University of Science and Technology (HKUST)
                </a>,
                supervised by{' '}
                <a href="http://www.huamin.org/">Prof. Huamin Qu </a>
                at the Department of Computer Science and
                Engineering.
                My research interest is computer-human interaction,
                information visualization, and visual text analytics. Before the
                Ph.D. study, I received my MSc(IT) Degree at HKUST in June, 2014,
                and Bachelor's Degree at School of Mathematics and Computional
                Science,{' '}
                <a href="http://www.sysu.edu.cn/2012/en/index.htm">
                  Sun Yat-sen University
                </a>{' '}
                in June, 2012.
              </li>
            </ul>
          </section>

          <section id="two">
            <h2>Selected Publications</h2>
            <h4>Asterisk (*) indicates corresponding authors. Full list can be found in <a href="https://scholar.google.com.hk/citations?user=5w2jTHQAAAAJ&hl=en">
                 Google Scholar 
                </a></h4>
            <References papers={pub} />
          </section>

          {/* <section id="three">
            <h2>Early Projects</h2>

            <Gallery
              images={projects.map(
                ({ id, src, thumbnail, caption, description }) => ({
                  src,
                  thumbnail,
                  caption,
                  description,
                })
              )}
            />
          </section> */}

          <section id="four">
            <h2>Contact:</h2>
            <table className="contacts">
              <tbody>
                <tr className="eachrow">
                  <td className="address">
                    <ul className="labeled-icons">
                      <li>
                        <h3 className="icon fa-home">
                          <span className="label">Address</span>
                        </h3>
                        Headquarters of Zhejiang Lab<br />
                        Hangzhou<br />
                        Zhejiang, China
                      </li>
                    </ul>
                  </td>
                  <td className="phones">
                    <ul className="labeled-icons">
                      <li>
                        <h3 className="icon fa-mobile">
                          <span className="label">Phone</span>
                        </h3>
                        (+86) 180 1976 1926
                      </li>
                      <li>
                        <h3 className="icon fa-envelope-o">
                          <span className="label">Email</span>
                        </h3>
                        <a href="#">fusiwei339[...At...]gmail.com</a>
                      </li>
                    </ul>
                  </td>
                  <td className="ssnet">
                    <a
                      href="https://bitbucket.org/fusiwei339/"
                      className="icon fa fa-github"
                    />
                    <a
                      href="https://www.linkedin.com/in/fu-siwei-89356a30/"
                      className="icon fa fa-linkedin"
                    />
                    <a
                      href="https://www.facebook.com/fu.siwei"
                      className="icon fa fa-facebook"
                    />
                    <a
                      href="https://twitter.com/fusiwei?lang=en"
                      className="icon fa fa-twitter"
                    />
                    <a
                      href="https://scholar.google.com.hk/citations?user=5w2jTHQAAAAJ&hl=en"
                      className="icon fa fa-google"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

      </div>
    )
  }
}

export default HomeIndex

export const pageQuery = graphql`
  query PageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js